import { Button } from "@mui/material";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { SvgIcon } from "@mui/material";

const CR_Button = ({buttonText,btnClick}) => {
    return (
        <>
            <Button
                className="btn-sty text-capitalize"
                onClick={btnClick}
                startIcon={
                    <SvgIcon fontSize="small">
                        <PlusIcon />
                    </SvgIcon>
                }
                variant="contained"
            >
                {buttonText}
            </Button>
        </>
    )
}
export default CR_Button;